import { Button } from "@progress/kendo-react-buttons";
import { useState, useEffect } from "react";
export interface RoundedTabGroupProps {
  children: React.ReactElement<RoundedTabProps>[];
  defaultTabName?: string;
  selectedTab?: string; // Controlled mode: parent controls which tab is selected
  onTabChange?: (tabName: string) => void; // Callback when tab changes
  className?: string;
  tabGroupClassName?: string;
  onClick: (tabName: string) => void;
}

export function RoundedTabGroup(props: RoundedTabGroupProps) {
  const [selectedPage, setSelectedPage] = useState<string>(
    props.selectedTab ?? props.defaultTabName ?? ""
  );

  // Sync with controlled prop when it changes
  useEffect(() => {
    if (props.selectedTab !== undefined && props.selectedTab !== selectedPage) {
      setSelectedPage(props.selectedTab);
    }
  }, [props.selectedTab]);

  const handleTabClick = (tabName: string) => {
    setSelectedPage(tabName);
    props.onClick(tabName);
    if (props.onTabChange) {
      props.onTabChange(tabName);
    }
  };

  return (

    <div className={props.className}>
      <div
        className={`inline-flex rounded-full shadow-sm bg-white ${props.tabGroupClassName}`}
        role="group"
      >
        {props.children.map((tabItem, index) => (
          <button
            type="button"
            className={
              "btn px-4 py-2 text-sm font-semibold rounded-full hover:opacity-80 focus:z-10 " +
              (selectedPage === tabItem.props.name
                ? "bg-mk-primary-bright text-white shadow-md"
                : "bg-white text-mk-very-dark-grey btn-secondary border-none")
            }
            onClick={() => handleTabClick(tabItem.props.name)}
            key={index}
          >
            {tabItem.props.title}
          </button>
        ))}
      </div>
      {props.children.map((tabItem, index) => (
        <div key={index}>
          {selectedPage === tabItem.props.name && tabItem.props.children}
        </div>
      ))}
    </div>
  );
  
  // <div></div>
  // return (
  //   <div className={props.className}>
  //     {/* Tabs and New Audit Button on Same Line */}
  //     <div className="flex items-center justify-between mb-4">
  //       {/* Tab Buttons */}
  //       <div className="inline-flex rounded-full shadow-sm bg-white" role="group">
  //         {props.children.map((tabItem, index) => (
  //           <button
  //             type="button"
  //             className={
  //               "btn px-4 py-2 text-sm font-semibold rounded-full hover:opacity-80 focus:z-10 " +
  //               (selectedPage === tabItem.props.name
  //                 ? "bg-mk-primary-bright text-white shadow-md"
  //                 : "bg-white text-mk-very-dark-grey btn-secondary border-none")
  //             }
  //             onClick={() => {
  //               setSelectedPage(tabItem.props.name);
  //               props.onClick(tabItem.props.name);
  //             }}
  //             key={index}
  //           >
  //             {tabItem.props.title}
  //           </button>
  //         ))}
  //       </div>

  //       {/* Button aligned to the right */}
  //       <div className="ml-4">
  //         <Button
  //           className="rounded-lg bg-mk-primary-bright text-white hover:bg-mk-light-grey hover:text-black focus:outline-none px-4 py-2"
  //           onClick={() => console.log('New Audit clicked')}
  //         >
  //           New Audit+
  //         </Button>
  //       </div>
  //     </div>

  //     {/* Content Section: Render content based on selected tab */}
  //     <div className="w-full flex-grow">
  //       {props.children.map((tabItem, index) => (
  //         <div key={index}>
  //           {selectedPage === tabItem.props.name && tabItem.props.children}
  //         </div>
  //       ))}
  //     </div>
  //   </div>
  // );

}

export interface RoundedTabProps {
  name: string;
  title: string;
  children: React.ReactNode;
}

export function RoundedTab(props: RoundedTabProps) {
  return <div>{props.children}</div>;
}
